import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import Spinner from "../Common/Spinner";
import CheckIcon from '@mui/icons-material/Check';

interface ChildProps {
  activeCompany: any;
  reloadTable: any;
}

const ActiveCompany: React.FC<ChildProps> = ({
  activeCompany,
  reloadTable,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (activeCompany.length) {
      let c = activeCompany.map((company: { email: any }) => {
        return company.email;
      });
    }
  }, [activeCompany]);

  const handleSubmit = () => {
    setIsLoading(true);
    if (activeCompany.length) {
      Service.activeCompanyId(activeCompany)
        .then((response) => {
          setIsLoading(false);
          CommonService.Toast.fire({
            title: "Company Active successfully",
            icon: "success",
          });
          reloadTable();
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    setIsLoading(false);
    handleClose();
  };

  return (
    <>
      <button className="primary-btn d-inline-flex me-1" onClick={handleShow}>
        <CheckIcon sx={{ me: 2 }} /> Active
        <span className="review--number text-secondary d-inline-flex align-items-center justify-content-center rounded-circle bg-white ms-2">
          {activeCompany.length}
        </span>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Active Company</Modal.Title>
          <p className="modal-text">
            Are you sure, you want to active this company?
          </p>
        </Modal.Header>
        <Modal.Footer className="justify-content-center bg-transparent">
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <Button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isLoading}
              >
                No
              </Button>
            </div>
            <div className="col-6 pe-0">
              <Button
                className="primary-btn w-100"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading && <Spinner />} Yes
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActiveCompany;
